export default [
    {
        routeName: 'offerFlow-steps-twocol-date',
        name: 'offerFlow.pages.stepDate.name.common',
    },
    {
        routeName: 'offerFlow-steps-twocol-passengers',
        name: 'offerFlow.pages.stepPassengers.name.common',
    },
] as ProductFlowStep[];
